<div class="page-detail-order-options-background intro-background"
     [ngStyle]="{ 'background-image': 'url(' + backgroundImageUrl + ')'}">
  <div class="gradient"></div>
  <div *ngIf="isPlaySports()" class="playSports-options">
    <div *ngIf="showOverlay" class="message">
      <app-overlay-message [hasPackageAlready]="hasPackageAlready" [isDowngrade]="isDowngrade" [hasDayPass]="hasDaypass" [hasTrial]="hasTrial"></app-overlay-message>
    </div>
    <div class="product-detail-order-body">
      <div *ngFor="let option of playSportsOptions; let i = index">
        <app-product-order-option [orderOption]="option"
                                  [x]="i"
                                  [y]="0"
                                  [hasOverlayMessage]="isDowngrade || hasDaypass || hasTrial || hasPackageAlready"
                                  [isDayPass]="option?.isDayPass"
                                  [isTrial]="option?.isTrial"
                                  [omapiId]="option?.omapiId"
                                  [pack]="option?.pack"
                                  (emitOrderProduct)="onEmitOrderProduct($event)"
                                  (emitOrderTrial)="onEmitOrderTrial($event)"
        ></app-product-order-option>
      </div>
    </div>
  </div>
</div>
